<template>
    <v-flex xs12 sm12 md12>
        <v-card text color="grey lighten-4" height="500" class="pa-4">
            <div class="wrapper-card-rounded">
                <v-card class="card-rounded">
                    <v-card-text>
                        <v-avatar size="100">
                            <img src="@/assets/of-logo.png" alt="Outfox AI">
                        </v-avatar>
                        <h3 class="headline grey--text mb-1">New to Outfox AI?<br>Sign Up!</h3>
                        <!-- <v-btn dark class="btn-login coral">
                            <i class="fab fa-google"></i>
                            Sign up with Google</v-btn> -->
                          <v-btn dark class="btn-login fbblue" @click.prevent="loginWithFacebook">
                              <i class="fab fa-facebook"></i>
                              Sign up with Facebook</v-btn>
                        <div class="subheading grey--text mt-2  mb-3">or <router-link to="login">Log In</router-link></div>

                    </v-card-text>
                </v-card>
            </div>
        </v-card>
    </v-flex>
</template>

<script>
  import helpers from '../../helpers/functions'
  export default {
    name: 'signup',
    data () {
      return {}
    },
    methods: {
      loginWithFacebook () {
        const promise = new Promise(resolve => {
          resolve(this.$store.dispatch('login'))
        })
        promise.then(res => {
          if (res) {
            this.$router.push('/')
            if (this.$store.state.featureToggle.appVersion === 'demo') {
              this.$store.dispatch('fetchDemoData')
            } else {
              this.$store.dispatch('fetchApiData')
            }
          } else this.$router.push('/welcome')
        })
          .catch(err => {
            helpers.handleError(err)
            this.$router.push({name: 'ErrorsHandling'})
          })
      }
    }
  }
</script>
